import { Fragment, useEffect, useState } from "react";
import { useGetLeasedEquipmentByOfficeId } from "../../LeasedEquipment/hooks/useGetLeasedEquipmentByOfficeId";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { mainSelectedTab } from "../../atoms";
import {
  leShowState,
  lEViewData,
  leFromOffice,
  ledAddState,
  leasedEquipmentOfficeId,
  ledEditState,
  rowForEditLeasedEquipment,
  selectedRowsLE,
  disableLEOfficeField,
} from "../../LeasedEquipment/atom/atom";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { useHistory } from "react-router-dom";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/solid";
import {
  EllipsisHorizontalCircleIcon,
  EllipsisVerticalIcon,
} from "@heroicons/react/24/outline";
import { Menu, Transition } from "@headlessui/react";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { useDeleteLE } from "../../LeasedEquipment/hooks/useDeleteLeasedEquipment";
import useDeactivateLicenseE from "../hooks/useDeactivateLicenseType";
import { toast } from "../../../../components/toastNotification";
import { useQueryClient } from "react-query";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import { useGetLeasedEquipmentForEdit } from "../../LeasedEquipment/hooks/useGetLeasedEquipmentForEdit";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
const OfficeLeasedEquipments = ({ data }) => {
  const queryClient = useQueryClient();
  const [leasedEquipmentDetails, setLeasedEquipmentDetails] = useState([]);
  const [, setShowState] = useRecoilState(leShowState);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [, setRowViewData] = useRecoilState(lEViewData);
  const [, setShowFromOffice] = useRecoilState(leFromOffice);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setleOfficeId] = useRecoilState(leasedEquipmentOfficeId);
  const [, setAddState] = useRecoilState(ledAddState);
  const [, setEditState] = useRecoilState(ledEditState);
  // const [, setRowLEForEdit] = useRecoilState(rowForEditLeasedEquipment);
  const setRowToEdit = useSetRecoilState(rowForEditLeasedEquipment);
  const [, setDisableOfficeField] = useRecoilState(disableLEOfficeField);
  const { data: leasedEquipmentData } = useGetLeasedEquipmentByOfficeId(
    data.officeId
  );
  const { mutate: getLEForEdit } = useGetLeasedEquipmentForEdit();
  const [selectedRows, setSelectedRows] = useRecoilState(selectedRowsLE);

  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [isBulkSelected, setIsBulkSelected] = useState(false);

  const editLeased = PERMISSIONS.permission_leasedequipment_edit;
  const deactivateLeased = PERMISSIONS.permission_leasedequipment_delete;

  useEffect(() => {
    if (leasedEquipmentData) {
      setLeasedEquipmentDetails(leasedEquipmentData);
    }
  }, [leasedEquipmentData]);

  const {
    mutate: BulkDeleteLeasedEquipments,
    isSuccess: deacSuccess,
    isError: deacError,
    data: deacResult,
    reset: resetDeacData,
  } = useDeactivateLicenseE();

  // Redirection to View Page
  const onClickRecordNumber = (rowData) => {
    setShowFromOffice(true);
    handleLink("leasedequipment");
    setShowState(true);
    setRowViewData(rowData);
  };

  const handleLink = (moduleName) => {
    const url = `/officesettings/${moduleName}`;
    history.push(moduleName);
    let userTabs = [];
    [...OfficeTabs].forEach((tabs) => {
      let temp = [...userPermissions].filter(
        (user) => user === tabs.permission
      );
      if (temp.length > 0)
        userTabs.push({
          to: tabs.to,
        });
    });
    const index = userTabs.findIndex((c) => c.to === url);

    setSelectedIndex(index);
  };

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Leased Equipment were deactivated successfully",
        "success"
      );
      queryClient.invalidateQueries(
        "GetLeasedEquipmentByOfficeId",
        data?.officeId
      );
      queryClient.invalidateQueries(["GetLeasedEquipment"]);
      setSelectedRows([]);
      //ssearchRefetch();
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Leased Equipments were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
      } else {
        toast.fire(
          "Bulk deactivation of Leased Equipmens failed",
          "Server Error: Cannot deactivate Leased Equipments",
          "error"
        );
      }
      queryClient.invalidateQueries(
        "GetLeasedEquipmentByOfficeId",
        data?.officeId
      );
    } else {
      toast.fire(
        "Bulk deactivation of Leased Equipments failed",
        "Server Error: Cannot deactivate Leased Equipments",
        "error"
      );
      queryClient.invalidateQueries(
        "GetLeasedEquipmentByOfficeId",
        data?.officeId
      );
    }
    resetDeacData();
  }

  // View all Button function
  const onClickViewAll = () => {
    handleLink("leasedequipment");
    setShowState(false);
    setleOfficeId(data.officeId);
  };

  // edit button function
  const onClickEdit = (rowDetails) => {
    getLEForEdit(rowDetails.recordNumber, {
      onSuccess: (res) => {
        setRowToEdit({
          ...res,
          leaseEndDate:
            res.leaseEndDate === null
              ? null
              : rowDetails.leaseEndDate.slice(0, 10),
          leaseStartDate:
            rowDetails.leaseStartDate === null
              ? null
              : rowDetails.leaseStartDate.slice(0, 10),
          isActive: !rowDetails.isActive,
        });
        setAddState(false);
        setEditState(true);
        handleLink("leasedequipment");
        setShowFromOffice(true);
        setDisableOfficeField(true);
      },
    });
  };

  useEffect(() => {
    setSelectedRows([]);
  }, [setSelectedRows]);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setOpenModalDelete(true);
    setSelectedRows(forDelete);
    setIsBulkSelected((prev) => !prev);
  };

  const handleBulkDelete = () => {
    const ids = selectedRows
      ? selectedRows.map((row) => row.recordNumber)
      : undefined;
    BulkDeleteLeasedEquipments(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRows?.length
    } ${
      selectedRows?.length > 1 ? "Leased Equipments" : "Leased Equipment"
    } ?`}</div>
  );

  return (
    <>
      {leasedEquipmentDetails?.length > 0 ? (
        <>
          {leasedEquipmentDetails?.map((leased, i) => {
            return (
              <div key={i} className="">
                <div className="grid grid-cols-1 sm:grid-cols-1">
                  <div className="p-4 ">
                    <div className="flex justify-between m-1 gap-2">
                      <span className="pr-2">
                        <div
                          className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                          onClick={() => onClickRecordNumber(leased)}
                        >
                          {leased.recordNumber
                            ? "LE-" +
                              String(leased.recordNumber).padStart(4, "0")
                            : ""}
                        </div>
                      </span>
                      {userPermissions.includes(editLeased) && (
                        <Menu as="div" className="items-center flex">
                          <div>
                            <Menu.Button className="">
                              <EllipsisHorizontalCircleIcon
                                className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                                aria-hidden="true"
                              />
                            </Menu.Button>
                          </div>
                          <Transition
                            as={Fragment}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                          >
                            <Menu.Items className="absolute right-0 mt-2 w-18 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none transform opacity-100 scale-100">
                              <div className="px-1 py-1">
                                <Menu.Item>
                                  {({ active }) => (
                                    <button
                                      buttonText="Edit"
                                      className={""}
                                      onClick={() => onClickEdit(leased)}
                                      disabled={false}
                                    >
                                      <label className="cursor-pointer fontLabel text-quaternary flex items-center place-content-center hover:text-primary underline   relative  px-2 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70">
                                        {" "}
                                        <PencilSquareIcon className="h-4 w-4 " />{" "}
                                        Edit
                                      </label>
                                    </button>
                                  )}
                                </Menu.Item>
                              </div>
                              {userPermissions.includes(deactivateLeased) && (
                                <div className="px-1 py-1">
                                  <Menu.Item>
                                    {({ active }) => (
                                      <button
                                        buttonText="Deactivate"
                                        className={
                                          !leased.isActive ||
                                          leased.status === "Inactive"
                                            ? "opacity-50"
                                            : "opacity-100"
                                        }
                                        onClick={() =>
                                          handleSelectedRowsChange([leased])
                                        }
                                        disabled={
                                          !leased.isActive ||
                                          leased.status === "Inactive"
                                            ? true
                                            : false
                                        }
                                      >
                                        <label className="cursor-pointer fontLabel text-secondary flex items-center place-content-center hover:text-hsecondary underline relative  px-2 text-xs font-medium">
                                          {" "}
                                          <TrashIcon className="h-4 w-4 " />{" "}
                                          Deactivate
                                        </label>
                                      </button>
                                    )}
                                  </Menu.Item>
                                </div>
                              )}
                            </Menu.Items>
                          </Transition>
                        </Menu>
                      )}
                    </div>
                    <div className="grid grid-cols-4 ">
                      <label className="col-span-2 mx-4 expandedLabel fontExpand">
                        Type:
                      </label>
                      <div className="col-span-2 expandedData fontExpand">
                        <span className="pr-2">{leased.typeName}</span>
                      </div>
                    </div>
                    <div className="grid grid-cols-4 ">
                      <label className="col-span-2 mx-4 expandedLabel fontExpand">
                        Make:
                      </label>
                      <div>
                        <span className="pr-2 ">{leased.makeName}</span>
                      </div>
                    </div>
                    <div className="grid grid-cols-4 ">
                      <label className="col-span-2 mx-4 expandedLabel fontExpand">
                        Model:
                      </label>
                      <div className="col-span-2 expandedData fontExpand">
                        <span className="pr-2">{leased.model}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
          {leasedEquipmentDetails.length > 2 && (
            <div className="bg-gray-50 p-2 flex justify-center">
              <button
                onClick={() => onClickViewAll()}
                className="text-primary underline font-semibold "
              >
                View All
              </button>
            </div>
          )}
        </>
      ) : (
        <div className="flex justify-center text-xs italic col-span-3 p-2">
          No Leased Equipment Found
        </div>
      )}
      {
        <ConfirmBoxDelete
          ModalTitle="Deactivate Leased Equipment"
          qConfirmation={deleteMessage}
          isOpen={openModalDelete}
          onClose={() => setOpenModalDelete(false)}
          onClickFunction={handleBulkDelete}
        />
      }
    </>
  );
};
export default OfficeLeasedEquipments;
